import useSWR from 'swr';
import { useState, useEffect, useMemo } from 'react';

const GET_FETCH_OPTIONS = () => {
	return {
		method: 'get',
		headers: {
			'Content-Type': 'application/json',
			"User-Agent": 'Mozilla/5.0'
		},
		mode: 'cors',
	}
}

const GET_FETCH_OPTIONS_AUTH = () => {
	return {
		method: 'get',
		headers: {
			'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
			'Content-Type': 'application/json',
			"User-Agent": 'Mozilla/5.0'
		},
		mode: 'cors',
	}
}

const sanitizeJSON = (jsonText) => {
	return jsonText
		.replace(/:\s*NaN\s*([,}])/g, ':null$1')
		.replace(/:\s*Infinity\s*([,}])/g, ':null$1')
		.replace(/:\s*-Infinity\s*([,}])/g, ':null$1');
};

const fetcher = ( url, query = '' ) => fetch(
	`${url}${query}`,
	GET_FETCH_OPTIONS()
).then(res => {
	// Get response as text first
	return res.text();
}).then(text => {
	// Sanitize the JSON response before parsing
	const sanitizedText = sanitizeJSON(text);
	return JSON.parse(sanitizedText);
})

const fetcherAuth = ( url, query = '' ) => fetch(
	`${url}${query}`,
	GET_FETCH_OPTIONS_AUTH()
).then(res => {
	if (res.status === 401) {
		if (!window.location.href.includes('/?sessionExpired=true') && localStorage.getItem('username')) {
			localStorage.setItem('username', '')
			localStorage.setItem('firstName', '')
			localStorage.setItem('lastName', '')
			localStorage.setItem('picture', '')
			localStorage.setItem('accessToken', '')
			localStorage.setItem('userId', '')
			window.location.href = '/?sessionExpired=true'
		}
	}
	if (res.status === 403) {
		window.location.href = '/'
	}
	// Get response as text first, then sanitize
	return res.text();
}).then(text => {
	// Sanitize the JSON response before parsing
	const sanitizedText = sanitizeJSON(text);
	return JSON.parse(sanitizedText);
})
export const baseUrl = (slug) => `${process.env.REACT_APP_API_URL}${slug}`

const POST_DATA_OPTIONS = (data) => {
	return {
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(data)
	}
}

const POST_DATA_OPTIONS_FORM = (formData) => {
	return {
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
		},
		body: formData
	}
}

//GET ********

export const useTopFifty = () => {
	const { data, error } = useSWR(baseUrl('/get-top50-index'), fetcher)
  return {
    data: data,
    isLoading: !error && !data,
    isError: error
  }
}

export const useAltcoinSeason = () => {
	let { data, error } = useSWR(baseUrl('/get-altcoin-season'), fetcher)
	let isloading = false
	if(!error && !data) {
		isloading = true
	}
	if (data) {
		data.data.index = {
			'daily_graph_data':data.data.daily_graph_data,
			'fivemin_graph_data':data.data.fivemin_graph_data
		}
	} else {
		data = {'data':{}}
		isloading = true
	}
	return {
		data: data.data,
		isLoading: isloading,
		isError: error
	}
}

export const useRecentIndexes = () => {
	const { data, error } = useSWR(baseUrl('/get-most-recent-indexes'), fetcher)

	return {
		data: data ? data.data : [],
		isLoading: !error && !data,
		isError: error
	}
}

export const usePopularIndexes = () => {
	const { data, error } = useSWR(baseUrl('/get-most-popular-indexes'), fetcher)

	return {
		data: data ? data.data : [],
		isLoading: !error && !data,
		isError: error
	}
}

export const usePerformers = () => {
	const { data, error } = useSWR(baseUrl('/performers'), fetcher)

	return {
		data: data ? data.data : [],
		isLoading: !error && !data,
		isError: error
	}
}

export const useAllIndexes = (sortField, sortOrder, indexType = "all") => {
	const { data, error } = useSWR(baseUrl(`/get-browsable-indexes?sortOrder=${sortOrder}&sortField=${sortField}&indexType=${indexType}`), fetcher)

	return {
		data: data ? data.data : [],
		isLoading: !error && !data,
		isError: error
	}
}

export const useBrowsableIndexes = (sortField, sortOrder, indexType = "bitformance") => {
	const { data, error } = useSWR(baseUrl(`/get-browsable-indexes?sortOrder=${sortOrder}&sortField=${sortField}&indexType=${indexType}`), fetcher)

	return {
		data: data ? data.data : [],
		isLoading: !error && !data,
		isError: error
	}
}

export const useSectorIndexes = (sortField, sortOrder) => {
	const { data, error } = useSWR(baseUrl(`/get-sector-indexes?sortOrder=${sortOrder}&sortField=${sortField}`), fetcher);
	if (data) {
		data.data.forEach( i => {
			i.constituents = i.crypto_ids.length
			i.subsectors.forEach(s => {
				s.index.constituents = s.index.crypto_ids.length
				s.index.name = s.index.industry
				if (s.index.weighting_method === 'equal_weight') {
					s.index.name = `EQW ${s.index.industry}`
				}

			})
		})
	}
	return {
	  data: data ? data.data : [],
	  taxonomyStats: data ? data.taxonomy_stats : null,
	  lastUpdated: data ? data.last_updated : "",
	  isLoading: !error && !data,
	  isError: error
	};
  };

  export const useCryptosByMarketCap = (sortField, sortOrder, page = 0, limit = 10) => {
  	const cacheKey = `${baseUrl('/get-coins-by-marketcap')}?limit=${limit}&sortOrder=${sortOrder}&sortField=${sortField}&page=${page + 1}`;
  	const { data, error, isLoading } = useSWR(cacheKey, fetcher)

  	return {
  		data: data ? data.data : [],
  		isLoading: isLoading,
  		isError: error
  	}
  }

export const useCryptosByVolume = (sortField, sortOrder, page = 0, limit=10) => {
	const cacheKey = `${baseUrl('/get-coins-by-volume')}?limit=${limit}&sortOrder=${sortOrder}&sortField=${sortField}&page=${page + 1}`;
	const { data, error, isLoading } = useSWR(cacheKey, fetcher)

	return {
		data: data ? data.data : [],
		isLoading: isLoading,
		isError: error
	}
}

export const useCryptoById = (id, isAuth) => {
	const { data, error } = useSWR(
		baseUrl(`/get-index?id=${id}`),
		isAuth ? fetcherAuth : fetcher
	)
	return {
		data: data,
		isLoading: !error && !data,
		isError: error
	}
}

export const useCoinBySymbol = (symbol) => {
	const { data, error } = useSWR(
		baseUrl(`/get-coin-data?symbol=${symbol}&start=1451692800`),
		fetcher
	)

	if (data) {
		data.data.initial_value = data.data.daily_graph_data.price.slice(-3000)[0]
	}

	return {
		data: data ? data.data: null,
		isLoading: !error && !data,
		isError: error
	}

}

export const searchForIndex = async (searchText) => {
	const data = await fetcher(baseUrl(`/search-index?search=${searchText}`))
	return data
}

// Caching on browser local storage
const CACHE_KEYS = {
  userIndexes: 'userIndexesCache',
  favoriteIndexes: 'favoriteIndexesCache'
};

export const clearCache = async (cacheKey) => {
  localStorage.removeItem(cacheKey);
  // Add a small delay to ensure React state updates
  await new Promise(resolve => setTimeout(resolve, 100));
};

export const clearAllCaches = async () => {
  Object.values(CACHE_KEYS).forEach(key => localStorage.removeItem(key));
  await new Promise(resolve => setTimeout(resolve, 100));
};

// Utility function to handle the caching logic
const createCachedHook = (endpoint, storageKey) => {
  const shouldFetchData = () => {
    const cache = localStorage.getItem(storageKey);
    if (!cache) return true;

    const parsedCache = JSON.parse(cache);
	if (!parsedCache.data || parsedCache.data.length === 0) return true;
	const { timestamp } = parsedCache;
    const now = new Date();
    const lastUpdate = new Date(timestamp);

    const currentMinutes = now.getMinutes();
    const remainder = currentMinutes % 5;
    const lastUpdateMinute = currentMinutes - remainder + (remainder <= 1 ? -4 : 1);

    const lastUpdateTime = new Date(now);
    lastUpdateTime.setMinutes(lastUpdateMinute, 0, 0);

    return lastUpdate < lastUpdateTime;
  };

  return () => {
    const [localData, setLocalData] = useState(null);
    const shouldFetch = shouldFetchData();

    const { data, error } = useSWR(
      shouldFetch ? baseUrl(endpoint) : null,
      fetcherAuth
    );

    useEffect(() => {
      const cache = localStorage.getItem(storageKey);
      if (cache) {
        const { data } = JSON.parse(cache);
        setLocalData(data);
      }
    }, []);

    useEffect(() => {
      if (data) {
        const cacheData = {
          data: data.data,
          timestamp: new Date().toISOString()
        };
        localStorage.setItem(storageKey, JSON.stringify(cacheData));
        setLocalData(data.data);
      }
    }, [data]);

    return {
      data: localData || [],
      isLoading: shouldFetch || !data,
      isError: error
    };
  };
};

// Create the hooks using the utility function
export const useMyIndexes = createCachedHook(
  '/get-user-indexes',
  CACHE_KEYS.userIndexes
);

export const useFavoriteIndexes = createCachedHook(
  '/get-favorited-indexes',
  CACHE_KEYS.favoriteIndexes
);
//GET AUTH **********
// export const useMyIndexes = () => {
// 	const { data, error } = useSWR(baseUrl('/get-user-indexes'), fetcherAuth)
// 	return {
// 		data: data ? data.data : [],
// 		isLoading: !error && !data,
// 		isError: error
// 	}
// }
//
// export const useFavoriteIndexes = () => {
// 	const { data, error } = useSWR(baseUrl('/get-favorited-indexes'), fetcherAuth)
//
// 	return {
// 		data: data ? data.data : [],
// 		isLoading: !error && !data,
// 		isError: error
// 	}
// }

export const useProfile = () => {
	const { data, error } = useSWR(baseUrl('/profile'), fetcherAuth)

	return {
		data: data,
		isLoading: !error && !data,
		isError: error
	}
}

export const useAreMarketCapCoinsAvailable = () => {
	const { data, error } = useSWR(baseUrl('/get-marketcap-coins'), fetcherAuth)

	return {
		data: data,
		isLoading: !error && !data,
		isError: error
	}
}

export const getAllCoins = async (fields = []) => {
  // Build query string if fields are provided
  let url = baseUrl('/get-all-coins');

  // If specific fields are requested, add them as query parameters
  if (fields.length > 0) {
    url += '?' + fields.join('&');
  }

  const response = await fetch(url, GET_FETCH_OPTIONS());
  const data = await response.json();

  // Process the data
  data.data.forEach(d => {
    d.image_url = d.logo;
  });

  return data;
}

//POST **********

export const login = async (email, password) => {
	const response = await fetch(baseUrl('/login'), POST_DATA_OPTIONS({ email, password }))
	const data = await response.json()
	if (response.ok) {
    	await clearCache(CACHE_KEYS.favoriteIndexes);
		await clearCache(CACHE_KEYS.userIndexes);
    }
	return data
}

export const registerAccount = async ({ email, password, username, first_name, last_name }) => {
	const response = await fetch(
		baseUrl('/register'),
		POST_DATA_OPTIONS({
			first_name,
			last_name,
			email,
			password,
			username
		})
	)
	const data = await response.json()
	return data
}

export const resetPassword = async (token, password, confirm_password) => {
	const response = await fetch(
		baseUrl(`/reset-link/${token}`),
		POST_DATA_OPTIONS({
			password,
			new_password: password,
			confirm_password
		})
	)
	const data = await response.json()
	return data
}

export const useConfirmEmailByToken = (token) => {
	const { data, error } = useSWR(baseUrl(`/email-confirmed/${token}`), fetcher)

	return {
		data: data ? data : [],
		isLoading: !error && !data,
		isError: error
	}
}

export const forgotPassword = async (email) => {
	const response = await fetch(
		baseUrl('/forgot-password'),
		POST_DATA_OPTIONS({
			email,
		})
	)
	const data = await response.json()
	return data
}

export const favoriteIndex = async (index_id) => {
	const response = await fetch(baseUrl('/favorites'), POST_DATA_OPTIONS({ index_id }))
	const data = await response.json()

	if (response.ok) {
    	await clearCache(CACHE_KEYS.favoriteIndexes);
    }
	return data
}

export const generateChartPreview = async (name,weighting_method,description,initial_value,cryptos,custom_weights = {}, rebalancing_interval, initial_timestamp) => {
	const response = await fetch(
		baseUrl('/create-chart-preview'),
		POST_DATA_OPTIONS({
			// name: 'Example',
			name,
			weighting_method,
			// description: 'Test',
			description,
			initial_value,
			initial_timestamp,
			cryptos,
			custom_weights,
			rebalancing_interval,
			logo: ''
		})
	)
	const data = await response.json()
	return data
}

export const createIndex = async (name, weighting_method, description = '', initial_value, cryptos, rebalancing_interval, custom_weights = {}, logo = '',  initial_timestamp) => {
	const response = await fetch(
		baseUrl('/create-new-index'),
		POST_DATA_OPTIONS({
			name,
			weighting_method,
			description,
			initial_value,
			initial_timestamp,
			cryptos,
			custom_weights,
			rebalancing_interval,
			logo
		})
	)
	const data = await response.json()
	if (response.ok) {
		await clearCache(CACHE_KEYS.userIndexes);
	}
	return data
}
export const editIndex = async (id, name, weighting_method, description = '', initial_value, cryptos, rebalancing_interval, custom_weights = {}, logo = '',  initial_timestamp) => {
	const response = await fetch(
		baseUrl('/edit-index'),
		POST_DATA_OPTIONS({
			id,
			name,
			weighting_method,
			description,
			initial_value,
			initial_timestamp,
			cryptos,
			custom_weights,
			rebalancing_interval,
			logo
		})
	)
	const data = await response.json()
	if (response.ok) {
		await clearCache(CACHE_KEYS.userIndexes);
	}
	return data
}

export const getIndex = async (id, isAuth) => {
	const response = await fetch(
		baseUrl(`/get-index?id=${id}`),
		POST_DATA_OPTIONS({
			isAuth
		})
	)
	const data = await response.json()
	return data
}

export const deleteIndex = async (index_id) => {
	const response = await fetch(
		baseUrl('/remove-index'),
		POST_DATA_OPTIONS({
			index_id
		})
	)
	const data = await response.json()
	if (response.ok) {
		await clearCache(CACHE_KEYS.userIndexes);
	}
	return data
}

export const uploadImage = async (imageFile, type = 'logo', indexId) => {
	const formData = new FormData();
	formData.append("file_obj", imageFile);
	formData.append("type", type);
	formData.append('id', indexId);
	const response = await fetch(baseUrl('/mime-files'), POST_DATA_OPTIONS_FORM(formData))
	const data = await response.json()
	return data
}

export const contactForm = async ({ username, subject, message, email }) => {
	const response = await fetch(
		baseUrl('/contact'),
		POST_DATA_OPTIONS({
			username,
			subject,
			message,
			email
		})
	)
	const data = await response.json()
	return data
}

export const contactFormBetaAccess = async ({ username,email,telegram,twitter,tier,message }) => {
	const response = await fetch(
		baseUrl('/contactAPIAccess'),
		POST_DATA_OPTIONS({
			username,
			email,
			telegram,
			twitter,
			tier,
			message
		})
	)
	const data = await response.json()
	return data
}
export const updateProfile = async (profile) => {
	const response = await fetch(baseUrl('/update-profile'), POST_DATA_OPTIONS({
		...profile
	}))
	const data = await response.json()
	return data
}

// export const useApiInfo = () => {
// 	const { data, error } = useSWR(baseUrl('/get-user-api-info'), fetcherAuth)
// 	console.log(data)
// 	if (data) {
// 		if (data.data) {
// 			data.data.forEach(d => {
// 				d.key = d['api-key']
// 			})
// 		} else {
// 			data.data = []
// 		}
// 	}
// 	return {
// 		data: data ? data.data : [],
// 		isValid: data ? true : false
// 	}
// }
// In useApiInfo hook
export const useApiInfo = () => {
    const { data, error, isLoading } = useSWR(baseUrl('/get-user-api-info'), fetcherAuth)

    const processedData = useMemo(() => {
        if (!data || !data.data) return [];
        return data.data.map(d => ({
            ...d,
            key: d['api-key']
        }));
    }, [data]);

    return {
        data: processedData,
        isValid: !!data,
        isLoading: !error && !data
    }
}

export const getRegenApiKeys = async () => {
	const response = await fetch(baseUrl('/regenerate-api-key'),POST_DATA_OPTIONS({}))
	const data = await response.json()
	return data
}

export const getNewApiKeys = async (tier, is_new_key) => {
	const response = await fetch(baseUrl('/regenerate-api-key'),POST_DATA_OPTIONS({tier,is_new_key}))
	const data = await response.json()
	return data
}

export const createCheckoutSubscriptionSession = async (price_id,interval) => {
  const response = await fetch(
	  baseUrl('/create-checkout-session'),
	  POST_DATA_OPTIONS({'price_id': price_id,'interval': interval})
  )
  const data = await response.json()
  return data
};
